module.exports = __webpack_public_path__ + "static/media/02-11.aabff884.png";